/**
 * ParallaxImage — wraps an <img> with a subtle scroll-linked parallax.
 * No-op on mobile + reduced-motion. Container clip lives in the caller.
 */
import useParallax from "./useParallax";

export default function ParallaxImage({ src, alt, className = "" }) {
    const { ref, style, className: parallaxCls } = useParallax({
        intensity: 0.12,
        maxPx: 18,
    });
    return (
        <div ref={ref} style={style} className={parallaxCls}>
            <img
                src={src}
                alt={alt}
                loading="eager"
                className={`w-full h-auto block ${className}`}
                data-testid="learn-article-hero-image"
            />
        </div>
    );
}
